"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQUIPMENT_KEYS = void 0;
exports.equipmentValues = equipmentValues;
const finance_1 = require("./finance");
/**
 * The equipment provider's key space.
 *
 * Adding a key here and not producing it in `equipmentValues` is a COMPILE
 * ERROR (that function `satisfies Record<EquipmentKey, string | undefined>`).
 */
exports.EQUIPMENT_KEYS = ['summary', 'count', 'total_price'];
/**
 * THE ONLY formatter for "2x K10 POS Terminal". billing-service used to build
 * this string itself; that duplicate is deleted in Task 8 so the phrasing can
 * never diverge between the contract and the invoice.
 */
function equipmentValues(lines) {
    if (lines.length === 0)
        return { summary: undefined, count: '0', total_price: undefined };
    return {
        summary: lines.map(l => `${l.quantity}x ${l.name}`).join(', '),
        count: String(lines.reduce((n, l) => n + l.quantity, 0)),
        total_price: (0, finance_1.dollars)(lines.reduce((sum, l) => sum + (l.unitPriceCents ?? 0) * l.quantity, 0)),
    };
}
//# sourceMappingURL=equipment.js.map